module.exports = __webpack_public_path__ + "img/three_6.dab860ab.png";